define([
    'jquery',
    'mage/storage',
    'jquery/jquery-storageapi'
], function ($) {
    return {
        init() {
            this.initCache();
            this.bindEvents();
            this.checkLangCookie();
        },

        initCache() {
            this.$body = $('body');
            this.langApiUrl = '/rest/' + window.storeCode + '/V1/language/suggest/';
            this.langListApiUrl = '/rest/' + window.storeCode + '/V1/language/list/';

            this.$langSuggestPopup = $('#langSuggestPopup');
            this.langSpan = $('.js-lang-suggest-code');
            this.langSelect = $('#langSuggestSelect');
        },

        bindEvents() {
            this.$body.on('click', '.js-lang-suggest-close', this.closePopup.bind(this))
            this.$body.on('click', '.js-lang-suggest-apply', this.applyLang.bind(this))
        },

        checkLangCookie() {
            if ($.cookieStorage.isSet('langCookie')) {
                if ($.cookieStorage.get('langCookie') === window.lang.trim().toUpperCase()) return;

                $.ajax({
                    url: this.langListApiUrl,
                    type: 'post',
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify({
                        currentUrl: window.location.href
                    }),
                    success: (response) => {
                        response.forEach((el) => {
                            if (el.language.trim().toUpperCase() === $.cookieStorage.get('langCookie')
                                && el.url !== window.location.href) {
                                window.location.href = el.url;
                            }
                        })
                    }
                });

                return;
            }

            this.detectCityByIp();
        },

        detectCityByIp() {
            this.getPosition()
                .then((position) => {
                    this.getLanguageSuggest(position.coords.latitude, position.coords.longitude)
                })
                .catch((err) => {
                    console.log(err);

                    if (err.message.startsWith("Only secure origins are allowed")) {
                        // coordinates for local debugg
                        // this.getLanguageSuggest('51.1801', '71.446') // KZ
                        // this.getLanguageSuggest('47.23617', '38.89688') // RU
                    }
                });
        },

        getPosition(options) {
            return new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject, options));
        },

        getLanguageSuggest(lat, lon) {
            $.ajax({
                url: this.langApiUrl,
                type: 'post',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({
                    currentUrl: window.location.href,
                    lon,
                    lat
                }),
                success: (response) => {
                    if (response.status === 'none') return;

                    this.langSuggest = response.suggest[0];
                    this.country = response.suggest[3];

                    this.openPopup(response.all_languages);
                }
            });
        },

        openPopup(languages) {
            this.langSpan.text(this.country);

            for (let i = 0; i < languages.length; i++) {
                const elObj = JSON.parse(languages[i]);

                this.langSelect.append(`
                <option value="${elObj.language}" data-url="${elObj.url}">
                    ${elObj.language}
                </option>
                `);
            }

            this.$langSuggestPopup.show();
        },

        closePopup(e) {
            e && e.preventDefault();

            $.cookieStorage.set('langCookie', window.lang.trim().toUpperCase());

            this.$langSuggestPopup.hide();
        },

        applyLang(e) {
            e.preventDefault();

            const value = this.langSelect.val().trim().toUpperCase();

            $.cookieStorage.set('langCookie', value);

            if (value === window.lang) {
                this.closePopup();

                return;
            }

            window.location.href = this.langSelect.find('option:selected').data('url');
        },
    }
})
